// Third party
import { PayloadAction } from '@reduxjs/toolkit';

// Components
import { IRootState } from './type';
import { initialState } from './slice';
import { TAccountRoot } from '../../types';

const reducers = {
  setAccountRoots: (state: IRootState, action: PayloadAction<IRootState['account_roots']>) => ({
    ...state,
    account_roots: action.payload,
  }),
  addAccountRoot: (state: IRootState, action: PayloadAction<TAccountRoot>) => ({
    ...state,
    account_roots: [...state.account_roots, action.payload],
  }),
  deleteAccountRoot: (state: IRootState, action: PayloadAction<number>) => ({
    ...state,
    account_roots: state.account_roots?.filter(r => r.id !== action.payload) || [],
  }),
  updateAccountRoot: (state: IRootState, action: PayloadAction<TAccountRoot>) => ({
    ...state,
    account_roots: state.account_roots?.map(r =>
      r.id === action.payload.id ? action.payload : r
    ) || [],
  }),
  resetAccountRootsInfo: () => initialState,
};

export { reducers };
